export default __webpack_public_path__ + "images/inventory-management-icon.png";